<template>
  <div class="payment-subaccount-form-step">
    <div v-if="isLoading" class="loading-state">
      <spinner />
    </div>

    <FranchisesSubaccountsForm
      v-else
      ref="formRef"
      :mode="mode"
      :provider-code="providerCode ?? undefined"
      :account-data="accountData ?? undefined"
      @validate="handleValidation"
    />
  </div>
</template>

<script setup lang="ts">
import { ref, onMounted } from 'vue';
import { log } from '@/utils/DebugLogger';
import FranchisesSubaccountsForm from './FranchisesSubaccountsForm.vue';

type Id = number | string;
type Mode = 'create' | 'edit';

interface Props {
  mode?: Mode;
  accountId?: Id | null;
  providerCode?: string | null;
  accountData?: Record<string, unknown> | null;
}

interface FormInstance {
  validate?: () => boolean;
  getFormData?: () => Record<string, unknown> | null;
}

const props = withDefaults(defineProps<Props>(), {
  mode: 'create',
  accountId: null,
  providerCode: null,
  accountData: null
});

const emit = defineEmits<{
  validate: [isValid: boolean];
}>();

// State
const isLoading = ref<boolean>(false);
const formRef = ref<FormInstance | null>(null);

// Methods
const handleValidation = (isValid: boolean): void => {
  emit('validate', isValid);
};

const validate = (): boolean => {
  return formRef.value?.validate?.() ?? false;
};

const getFormData = (): Record<string, unknown> | null => {
  return formRef.value?.getFormData?.() ?? null;
};

// Lifecycle
onMounted(() => {
  log('FranchisesSubaccountsFormStep', 'onMounted', 'Component mounted', { mode: props.mode });
});

// Expose methods for parent
defineExpose({
  validate,
  getFormData
});
</script>

<style scoped>
.payment-subaccount-form-step {
  min-height: 200px;
}

.loading-state {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 200px;
}
</style>
